import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import en from "../data/data.json";
import cs from "../data/data_cs.json";

export const About = (props) => {
  const { language } = useContext(LanguageContext);
  const translations = language === "cs" ? cs : en;

  // always take paragraph from current translations so the component updates on language switch
  const paragraph =
    (translations.About && translations.About.paragraph) ||
    (props.data && props.data.paragraph) ||
    "";

  // const connectVariants = ["Let's connect", "Let’s connect", "Let´s connect"];
  const connectVariants = [
    "Let's connect",
    "Let’s connect",
    "Let´s connect",
    "Pojďme se propojit",
    "Kontaktujte nás",
    "Napište nám",
  ];

  const renderParagraphWithLink = (text = paragraph) => {
    if (!text) return null;
    // find any known variant and split around it
    for (const v of connectVariants) {
      const idx = text.indexOf(v);
      if (idx !== -1) {
        const before = text.slice(0, idx);
        const after = text.slice(idx + v.length);
        return (
          <p>
            {before}
            <a
              href="#contact"
              style={{ color: "inherit", textDecoration: "underline" }}
            >
              {v}
            </a>
            {after}
          </p>
        );
      }
    }
    // fallback — preserve line breaks
    return <p>{text}</p>;
  };

  return (
    <div id="about" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>{translations.About?.title}</h2>
        </div>
        <div className="about-text">
          {renderParagraphWithLink(paragraph)}
        </div>
      </div>
    </div>
  );
};
